import $ from 'jquery';
import Mark from 'mark.js';

/* global x5script */

class Searched {
  constructor() {
    this.enable = x5script.searchHighlight.enable;
    this.searchedPhrase = x5script.searchHighlight.phrase;
    this.searchArea = $('.js-searched');

    if (!this.enable || this.searchedPhrase === '' || !this.searchArea.length) {
      return;
    }

    this.accuracy = x5script.searchHighlight.accuracy;
    this.scrollToFirst = x5script.searchHighlight.scroll;

    this.init();
    this.scroll();
  }

  init() {
    const instance = new Mark(document.querySelector('.js-searched'));

    instance.mark(this.searchedPhrase, {
      accuracy: this.accuracy, // partially, exactly, complementary
      className: 'js-search-highlight',
    });
  }

  scroll() {
    $(window).on('load', () => {
      if (this.scrollToFirst) {
        const firstHighlight = $('.js-search-highlight').first();

        if (firstHighlight.length) {
          $('body, html')
            .stop()
            .animate(
              {
                scrollTop: firstHighlight.offset().top - 100,
              },
              500,
            );
        }
      }
    });
  }
}

export default new Searched();



// WEBPACK FOOTER //
// ./src/scripts/modules/searched.js